// Querys and Mutations
import {
    ALL_ACTIVE,
    GET_WITH_PAGINATION,
    DELETE,
    CHANGE_STATUS,
    CREATE,
    UPDATE
} from '@/graphql/config/CostCenterGraphql'

// models
import { Paginator, ResponseDefault } from '@/models'
import { CostCenterModel, CostCenterForm, CostCenterWithPagination } from '@/models/config'

// apollo
import { apolloClient } from '@/apollo'

class CostCenterService {
    /**
     * Queries
     */
    async getCostCenterActivated (): Promise<CostCenterModel[]> {
        const result = await apolloClient.query({
            query: ALL_ACTIVE
        })
        return result.data.costsCentersActive
    }

    async getWithPagination (perPage = 10, page = 1): Promise<CostCenterWithPagination> {
        const result = await apolloClient.query({
            query: GET_WITH_PAGINATION,
            variables: {
                page: page,
                perPage: perPage
            }
        })
        const pagination: Paginator = result.data.costsCentersWithPagination.paginatorInfo
        const data: [CostCenterModel] = result.data.costsCentersWithPagination.data
        const response: CostCenterWithPagination = {
            objects: data,
            pagination: pagination
        }
        return response
    }

    /**
     * Mutations
     */
    async create (form: CostCenterForm): Promise<CostCenterModel> {
        const result = await apolloClient.mutate({
            mutation: CREATE,
            variables: {
                input: form
            }
        })
        return result.data.createCostCenter
    }

    async update (id: number, form: CostCenterForm): Promise<CostCenterModel> {
        const result = await apolloClient.mutate({
            mutation: UPDATE,
            variables: {
                id: id,
                input: form
            }
        })
        return result.data.updateCostCenter
    }

    async changeStatus (id: number, status: boolean): Promise<CostCenterModel> {
        const result = await apolloClient.mutate({
            mutation: CHANGE_STATUS,
            variables: {
                id: id,
                input: {
                    is_active: status
                }
            }
        })
        return result.data.updateCostCenter
    }

    async delete (id: number): Promise<ResponseDefault> {
        await apolloClient.mutate({
            mutation: DELETE,
            variables: {
                id: id
            }
        })
        return {
            success: true,
            errors: []
        }
    }
}

export default new CostCenterService()
